import { render, staticRenderFns } from "./MyReserveCardComponent.vue?vue&type=template&id=381572a3&"
import script from "./MyReserveCardComponent.vue?vue&type=script&lang=js&"
export * from "./MyReserveCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports